import React from "react";
import { Grid } from "../../../common/utils/mui-imports";

// Types
interface StatusStatisticsDTO {
  Id: number;
  StatusName: string;
  Count: number;
  DisplayOrder?: number; // Optional if you're using it
}

interface InspectionAssignmentOverviewStatusProps {
  statusStatistics: StatusStatisticsDTO[];
  selectedStatus: number;
  onStatusClick: (statusId: number) => void;
  statusFilterRef?: React.RefObject<HTMLDivElement>;
}

const InspectionAssignmentOverviewStatus: React.FC<
  InspectionAssignmentOverviewStatusProps
> = ({ statusStatistics, selectedStatus, onStatusClick, statusFilterRef }) => {
  const getStatusClassName = (statusId: number): string => {
    let className = `status-pill new-status status-${statusId}`;

    if (selectedStatus === statusId) {
      className += " selected";
    }

    return className;
  };

  return (
    <div className="w-100">
      <Grid container ref={statusFilterRef}>
        {/* Status Filter */}
        {statusStatistics?.length > 0 && (
          <Grid item xl={8} lg={8} md={8} sm={12} xs={12}>
            <Grid container className="inspection-stat-wrap">
              <div
                className="standart-status-change mb-5 d-flex"
                style={{
                  borderRight: "unset",
                  borderLeft: "unset",
                  zIndex: "10",
                }}
              >
                <span className="mr-5 type-name fx flex-right">Status: </span>
                <Grid container className="status-wrp">
                  {statusStatistics.map(
                    (status: StatusStatisticsDTO, index: number) => (
                      <div
                        className="standards-status new-standards-status"
                        key={`status_${index}`}
                        onClick={() => onStatusClick(status.Id)}
                      >
                        <span className={getStatusClassName(status.Id)}>
                          {`${status.StatusName} (${status.Count})`}
                        </span>
                      </div>
                    )
                  )}
                </Grid>
              </div>
            </Grid>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default InspectionAssignmentOverviewStatus;
